// src/api/cropService.js
import axiosInstance from './axiosInstance';
import { getaccesstoken } from '../context/AuthContext'; // use central token helper

const apiPrefix = process.env.REACT_APP_API_PREFIX;

/**
 * Build request headers. Include auth-token when expert = true.
 * Note: accept-language is handled by axiosInstance interceptor.
 */
const buildHeaders = (expert = false) => {
  if (!expert) return {};
  const token = getaccesstoken();
  return { 'auth-token': token };
};

export async function fetchCropDetails(cropId, expert = false) {
  try {
    const response = await axiosInstance.get(`${apiPrefix}crops/${cropId}`, {
      headers: buildHeaders(expert),
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching crop details for crop ${cropId}:`, error);
    throw error;
  }
}

export async function fetchCrops(expert = false) {
  try {
    const response = await axiosInstance.get(`${apiPrefix}crops`, {
      headers: buildHeaders(expert),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching crops:', error);
    throw error;
  }
}

export async function fetchDiseases(cropId, expert = false) {
  try {
    const response = await axiosInstance.get(`${apiPrefix}crops/${cropId}/disease`, {
      headers: buildHeaders(expert),
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching diseases for crop ${cropId}:`, error);
    throw error;
  }
}

export async function fetchSymptomsByDisease(diseaseId, expert = false) {
  try {
    const response = await axiosInstance.get(`${apiPrefix}disease/${diseaseId}/symptoms`, { 
      headers: buildHeaders(expert), 
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching symptoms for disease ${diseaseId}:`, error);
    throw error;
  }
}

export async function fetchSymptomsByLevel(cid, level, expert = false) {
  try {
    const response = await axiosInstance.get(`${apiPrefix}crops/${cid}/symptom/level/${level}`, { 
      headers: buildHeaders(expert),
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching symptoms for crop ${cid} at level ${level}:`, error);
    throw error;
  }
}

export async function fetchChildrenSymptoms(cid, level, parentSid, expert = false) {
  try {
    // Fixed endpoint order to match parameter order - level then parentSid
    const response = await axiosInstance.get(`${apiPrefix}crops/${cid}/symptom/${level}/children/${parentSid}`, { 
      headers: buildHeaders(expert), 
    });
    if (response.data) {
      return Array.isArray(response.data) ? response.data : [response.data];
    } else {
      console.warn(`No data returned for children symptoms query`);
      return [];
    }
  } catch (error) {
    console.error(`Error fetching children symptoms for crop ${cid}, level ${level}, parent ${parentSid}:`, error);
    return [];
  }
}

export async function fetchDiseaseDetails(diseaseId, expert = false) {
  try {
    const response = await axiosInstance.get(`${apiPrefix}disease/${diseaseId}`, { 
      headers: buildHeaders(expert), 
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching disease details for disease ${diseaseId}:`, error);
    throw error;
  }
}

export async function fetchNextSymptomsOrDisease(cid, selectedSymptomIds, expert = false) {
  try {
    const selParam = JSON.stringify(selectedSymptomIds);
    const response = await axiosInstance.get(`${apiPrefix}algo`, {
      params: {
        cid: cid,
        sel: selParam,
      },
      headers: buildHeaders(expert),
    });
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching next symptoms or disease:',
      error.response?.data || error.message
    );
  }
}
